export default "__VITE_ASSET__07F0_UM2__"